import { Link } from 'gatsby'
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import { Button, Image } from 'react-bootstrap'
import IconSlider from '../../../asset/images/IconSlider.svg'
import useLink from '../../../hooks/useLink'

export interface ButtonLinkType {
  link?: string
  type: 'next' | 'back'
  text?: string
  disabled?: boolean
  onClick?: () => void
  state?: {
    createSteps: boolean
    [key: string]: unknown
  }
}

const ButtonLink = (props: ButtonLinkType): JSX.Element => {
  const { t } = useTranslation()
  const routerChange = useLink()
  return (
    <>
      {props.type === 'next' ? (
        <div className="next-step">
          <Link
            to={props.link ? routerChange + props.link : routerChange}
            state={props.state}
          >
            <Button
              className="next-step__button"
              disabled={props.disabled}
              onClick={props.onClick}
            >
              {props.text ? (
                props.text
              ) : (
                <Trans>{t('booking-button-next')}</Trans>
              )}
              <Image src={IconSlider} className="icon-next" />
            </Button>
          </Link>
        </div>
      ) : (
        ''
      )}
      {props.type === 'back' ? (
        <div className="back-list">
          <Link
            to={props.link ? routerChange + props.link : routerChange}
            state={props.state}
          >
            <Button className="back-list__button" onClick={props.onClick}>
              <Image src={IconSlider} className="icon-back" />
              {props.text ? props.text : <Trans>share.back</Trans>}
            </Button>
          </Link>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default ButtonLink
